<!-- 状态文本组件， 根据不同的状态，文本前显示不同颜色的圆点 -->
<template>
  <span class="std-status-text" :class="[type ? `has-dot std-status-text--${type}` : '']">
    <slot></slot>
  </span>
</template>
<script>
  export default {
    name: 'StdStatusText',
    props: {
      type: {
        type: String
      }
    }
  };
</script>
<style lang="less">
  .std-status-text {
    display: inline-block;
    position: relative;

    &.has-dot {
      padding-left: 12px;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        border-radius: 50px;
      }
    }
    &--pending::before {
      background: #8c8c8c;
    }
    &--doing::before {
      background: #0a7ff5;
    }
    &--success::before {
      background: #0fba5a;
    }
    &--failure::before {
      background: #fb2626;
    }
  }
</style>
